function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fill: "#75D640",
  fillRule: "evenodd",
  d: "M11.78 23C5.15 23 0 17.851 0 11.78 0 5.15 5.149 0 11.78 0 17.851 0 23 5.149 23 11.78 23 17.851 17.851 23 11.78 23zm0-9.537a1.683 1.683 0 100-3.365 1.683 1.683 0 000 3.365z"
});

var SvgImgCircle2 = function SvgImgCircle2(props) {
  return React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyMyIgaGVpZ2h0PSIyMyIgdmlld0JveD0iMCAwIDIzIDIzIj4KICA8cGF0aCBmaWxsPSIjNzVENjQwIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMS43ODA0ODc4LDIzIEM1LjE0ODcyNTM4LDIzIDAsMTcuODUxMjc0NiAwLDExLjc4MDQ4NzggQzAsNS4xNDg3MjUzOCA1LjE0ODcyNTM4LDAgMTEuNzgwNDg3OCwwIEMxNy44NTEyNzQ2LDAgMjMsNS4xNDg3MjUzOCAyMywxMS43ODA0ODc4IEMyMywxNy44NTEyNzQ2IDE3Ljg1MTI3NDYsMjMgMTEuNzgwNDg3OCwyMyBaIE0xMS43ODA0ODc4LDEzLjQ2MzQxNDYgQzEyLjcwOTk0MjYsMTMuNDYzNDE0NiAxMy40NjM0MTQ2LDEyLjcwOTk0MjYgMTMuNDYzNDE0NiwxMS43ODA0ODc4IEMxMy40NjM0MTQ2LDEwLjg1MTAzMyAxMi43MDk5NDI2LDEwLjA5NzU2MSAxMS43ODA0ODc4LDEwLjA5NzU2MSBDMTAuODUxMDMzLDEwLjA5NzU2MSAxMC4wOTc1NjEsMTAuODUxMDMzIDEwLjA5NzU2MSwxMS43ODA0ODc4IEMxMC4wOTc1NjEsMTIuNzA5OTQyNiAxMC44NTEwMzMsMTMuNDYzNDE0NiAxMS43ODA0ODc4LDEzLjQ2MzQxNDYgWiIvPgo8L3N2Zz4K";
export { SvgImgCircle2 as ReactComponent };